// extracted by mini-css-extract-plugin
export default {"container":"HttpIncidents_container__NE9iP"};